import { hooks, mui, React, ts } from '_core';

import WidgetHistories from '_components/widget-histories';

import { DraftParams } from './types';

type FormProps = {
  params: DraftParams;
  setParams: (_p: DraftParams) => void;
  context?: ts.types.backtest.BacktestAnaylsisContext;
};

const Form = ({ params, setParams, context }: FormProps) => {
  const [selectedHistories, setSelectedHistories] = React.useState(
    params.histories || ([] as ts.enums.HISTORY_ENUM_EXTENDED[])
  );
  const uiStyles = hooks.useUiStyles();

  React.useEffect(() => {
    const data = { histories: selectedHistories };

    setParams({ ...params, ...data });
  }, [selectedHistories]);

  return (
    <mui.core.Box sx={uiStyles.widgetEditMode}>
      <mui.core.Box mb={2}>
        <WidgetHistories<true> multiple context={context} value={selectedHistories} setValue={setSelectedHistories} />
      </mui.core.Box>
    </mui.core.Box>
  );
};

export default Form;
